import './App.css';
import React, { useState, useEffect } from 'react';
import Loader from './components/Loader';
import Button from './components/Button';
import HelpModal from './components/Modal/Help';
import TutorialModal from './components/Modal/Tutorial';
import WebHeader from './components/Header/web';
import PageLayout from './components/PageLayout';
import ResultModal from './components/Modal/Result';
import GoBackModal from './components/Modal/GoBack';
import MobileHeader from './components/Header/mobile';
import WebGameContainer from './components/GameContainer/web';
import MobileGameContainer from './components/GameContainer/mobile';
import { TimeToMidnight } from './components/Timers/TimeToMidnight';
import { reverseArr } from './utils/reverseArr';
import ShowHintModal from './components/Modal/ShowHint';
import useGameplay from './hooks/useGameplay';

function Gameplay({ isMobile }) {
    const [showHelp, setShowHelp] = useState(false);
    const [showResult, setShowResult] = useState(false);
    const [showGoBack, setShowGoBack] = useState(-1);
    const [showHintModal, setShowHintModal] = useState(false);
    const [showTutorial, setShowTutorial] = useState(false);

    const {
        head, tail,
        blocksFwd, blocksBck,
        direction, setDirection,
        setGoBackDir,
        strikes, gameStatus,
        guessStatus,
        check, goBack, triggerHint, getTodaysPuzzle, getUsedIds, markTutorialSeen,
    } = useGameplay({ setShowHelp, setShowResult, setShowGoBack, setShowTutorial });

    useEffect(() => {
        if (gameStatus === 'game over' || gameStatus === 'game won') {
            setShowResult(true);
        }
    }, [gameStatus]);

    const prepGoBack = (idx, d) => {
        if (gameStatus === 'game over' || gameStatus === 'game won') {
            setShowGoBack(-1);
            return;
        }
        setShowGoBack(idx);
        setGoBackDir(d);
    };

    return (
        <PageLayout isMobile={isMobile} setShowHelp={setShowHelp}>
            <title>CineSnake</title>
            {isMobile
                ? <MobileHeader strikes={strikes} setShowHelp={setShowHelp} />
                : <WebHeader strikes={strikes} setShowHelp={setShowHelp} />
            }
            {gameStatus === "loading" && <div><Loader show={gameStatus === "loading"}/></div>}
            {gameStatus === "loading" ? null : (
                isMobile ?
                    <MobileGameContainer
                        guessStatus={guessStatus}
                        head={head}
                        isMobile={isMobile}
                        check={check}
                        tail={tail}
                        gameStatus={gameStatus}
                        blocksFwd={blocksFwd}
                        blocksBck={blocksBck}
                        setDirection={setDirection}
                        direction={direction}
                        setShowGoBack={prepGoBack}
                        usedIds={getUsedIds()}
                        triggerHint={() => setShowHintModal(true)}
                    />
                    :
                    <WebGameContainer
                        guessStatus={guessStatus}
                        head={head}
                        isMobile={isMobile}
                        check={check}
                        tail={tail}
                        gameStatus={gameStatus}
                        setShowGoBack={prepGoBack}
                        blocksFwd={blocksFwd}
                        blocksBck={blocksBck}
                        setDirection={setDirection}
                        direction={direction}
                        usedIds={getUsedIds()}
                        triggerHint={() => setShowHintModal(true)}
                    />
            )}
            {showTutorial && <TutorialModal
                show={showTutorial}
                isMobile={isMobile}
                onClose={() => {
                    markTutorialSeen();
                    setShowTutorial(false);
                }}
            />}
            {showHelp && <HelpModal
                onClose={() => setShowHelp(false)}
                show={showHelp}
                onWatchTutorial={() => {
                    setShowHelp(false);
                    setShowTutorial(true);
                }}
            />}
            {(gameStatus === 'game over' || gameStatus === 'game won') && (
                <>
                    <Button onClick={() => setShowResult(true)} text="See Today's Results" />
                    <TimeToMidnight getTodaysPuzzle={getTodaysPuzzle} />
                </>
            )}
            {showResult && <ResultModal
                onClose={() => setShowResult(false)}
                show={showResult}
                strikes={strikes}
                blocks={[...blocksFwd, ...reverseArr(blocksBck)]}
                head={head}
                tail={tail}
                gameStatus={gameStatus}
            />}
            {showGoBack > -1 && <GoBackModal
                onClose={() => setShowGoBack(-1)}
                show={showGoBack > -1}
                goBack={() => goBack(showGoBack)}
                strikes={strikes}
            />}
            {showHintModal && <ShowHintModal
                onClose={() => setShowHintModal(false)}
                show={showHintModal}
                strikes={strikes}
                triggerHint={async () => { await triggerHint(); setShowHintModal(false); }}
                relevantBlock={direction === 'fwd' ?
                    (blocksFwd.length === 0 ? head : blocksFwd[blocksFwd.length -1])
                    :
                    (blocksBck.length === 0 ? tail : blocksBck[blocksBck.length -1])
                }
            />}
        </PageLayout>
    );
}

export default Gameplay;
